import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

const resolveTimestamp = (value) => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const parsed = new Date(value);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed;
    }
  }

  return new Date();
};

/**
 * Minimal Timeline write for a bare dated fact (e.g. an admission/discharge date
 * from a Document). Deliberately has none of behaviorIncidentService's
 * severity/triggerNotes/suspectedTriggers fields — those are behavior-specific
 * and don't apply here.
 */
export const saveTimelineFactEntry = async ({ childId, factData = {}, userId, sourceNote = null } = {}) => {
  const timestamp = resolveTimestamp(factData.date);
  const label = String(factData.label || '').trim();

  const docData = {
    childId,
    status: 'active',
    createdBy: userId || null,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    timestamp,
    entryDate: timestamp.toDateString(),
    entryDayKey: timestamp.toISOString().slice(0, 10),
    category: 'log',
    type: 'log',
    timelineType: 'document_fact',
    entryType: 'document_fact',
    title: label,
    text: label,
    sourceText: String(factData.sourceText || '').trim(),
    sourceNoteId: sourceNote?.id || null,
    sourceNotePath: sourceNote?.path || '',
    sourceNoteCollection: sourceNote?.collection || '',
    dateApproximate: Boolean(factData.dateApproximate),
    approximateDateText: String(factData.dateText || '').trim(),
    medicationSnapshot: Array.isArray(factData.medications)
      ? factData.medications.map((medication) => ({
          name: String(medication.name || '').trim(),
          dose: String(medication.dose || '').trim(),
          unit: String(medication.unit || '').trim(),
          schedule: String(medication.schedule || '').trim(),
        }))
      : [],
  };

  const docRef = await addDoc(collection(db, 'dailyLogs'), docData);

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('captureez:timeline-entry-created', {
      detail: { id: docRef.id, ...docData, childId },
    }));
    window.dispatchEvent(new CustomEvent('captureez:timeline-refresh', {
      detail: { childId, collection: 'dailyLogs', entryId: docRef.id },
    }));
  }

  return {
    success: true,
    id: docRef.id,
    entry: { id: docRef.id, ...docData },
  };
};

export default saveTimelineFactEntry;
